module.exports = __webpack_public_path__ + "img/goods12.b84b9c6e.jpg";